<div class="btn-icon-load">
    <img class="button-loader-img-icon" src="assets/icons/button-loader-dark.svg" alt="" />
</div>
  
